import {CardContent, Divider} from "@mui/material";
import React from "react";


export const ContentKk = () => {
    return (
        <CardContent className="space-y-6 p-6 text-sm leading-relaxed">
            <div className="text-center space-y-1">
                <h1 className="text-xl font-bold">ҚОҒАМДЫҚ ОФЕРТА ШАРТЫ</h1>
                <p>"Электронная торговая площадка" электрондық сауда алаңына қатысу туралы</p>
                <p><strong>Орналасқан жері:</strong> Қосшы қ., Қазақстан Республикасы</p>
                <p><strong>Нұсқасы:</strong> 15.05.2025</p>
            </div>

            <Divider/>

            <p>
                Осы құжат Электронная торговая площадка ЖШС (бұдан әрі — "Оператор") ұсынған қоғамдық оферта (бұдан әрі — "Шарт") болып табылады. Оператордың атынан Жарғы негізінде әрекет ететін Бас директор _ кез келген заңды тұлғаға немесе жеке кәсіпкерге (бұдан әрі — "Қатысушы") "Электронная торговая площадка" электрондық сауда алаңының қызметтерін пайдалануға қол жеткізу үшін ұсынады.
            </p>

            <p>
                Осы офертаны қабылдау Қатысушы келесі әрекеттердің бірін жасаған кезде аяқталған болып есептеледі:
                <ul className="list-disc pl-6 mt-2">
                    <li>Электронная торговая площадка платформасында <a
                        className="text-blue-600 underline" href="https://etpzakup.kz/"
                        target="_blank" rel="noopener noreferrer">https://etpzakup.kz/</a> мекенжайы бойынша тіркеу
                        рәсімін аяқтап, қол қойылған тіркеу нысанын ұсынған кезде (1-қосымша);
                    </li>
                    <li>Электронная торговая площадка платформасында тіркеліп, шотқа сәйкес төлем жасаған кезде (2-қосымша).
                    </li>
                </ul>
            </p>

            <Divider/>
            <h2 className="text-lg font-semibold">1. АНЫҚТАМАЛАР</h2>
            <p>Осы Шартта қолданылатын барлық терминдер осы бөлімде немесе Электронная торговая площадка платформасының ресми сайтында
                жарияланған Глоссарийде түсіндіріледі.</p>

            <h2 className="text-lg font-semibold">2. ШАРТТЫҢ МӘНІ</h2>
            <p>Оператор Қатысушыға Электронная торговая площадка электрондық сауда платформасының (бұдан әрі — "Платформа") функционалына қол
                жеткізуді қолданыстағы тарифтерге (3-қосымша) сәйкес ұсынады. Қатысушы Платформа ережелерін (2-қосымша)
                және осы Шарттың талаптарын сақтауға міндеттенеді.</p>

            <h2 className="text-lg font-semibold">3. ТАРАПТАРДЫҢ ҚҰҚЫҚТАРЫ МЕН МІНДЕТТЕРІ</h2>
            <h3 className="font-medium">3.1 Оператордың міндеттері:</h3>
            <ul className="list-disc pl-6">
                <li>Платформаның функцияларына қол жеткізуді қамтамасыз ету;</li>
                <li>Деректердің тұтастығын, құпиялылығын және техникалық қолдауды қамтамасыз ету;</li>
                <li>Қатысушыларды ережелер немесе тарифтер өзгергені туралы кемінде 5 жұмыс күні бұрын хабардар ету;
                </li>
                <li>Қолданыстағы заңнама мен стандарттарға сәйкес құжаттама, есеп беру және қолдау көрсету.
                </li>
            </ul>

            <h3 className="font-medium">3.2 Қатысушының міндеттері:</h3>
            <ul className="list-disc pl-6">
                <li>Дәл және өзекті ақпарат ұсыну;</li>
                <li>Платформаны тек заңды және рұқсат етілген мақсаттарда пайдалану;</li>
                <li>Құпиялылықты, деректерді қорғауды және адал сауда қағидаттарын сақтау;</li>
                <li>Платформа ережелеріне сәйкес барлық қаржылық және реттеуші міндеттемелерді орындау.</li>
            </ul>

            <h2 className="text-lg font-semibold">4. ҚАРЖЫЛЫҚ ШАРТТАР</h2>
            <ul className="list-disc pl-6">
                <li>Барлық тарифтер мен төлем шарттары ресми веб-сайтта жарияланған.</li>
                <li>Аналитика, кеңейтілген қол жеткізу және т.б. сияқты қосымша қызметтер үшін төлем алынуы мүмкін.
                </li>
                <li>Барлық транзакциялар, шот-фактуралар және құжаттар электрондық түрде өңделеді.</li>
                <li>Қаражатты қайтару көрсетілген шарттарға сәйкес 10 жұмыс күні ішінде жүзеге асырылады.
                </li>
            </ul>

            <h2 className="text-lg font-semibold">5. ЖАУАПКЕРШІЛІК</h2>
            <ul className="list-disc pl-6">
                <li>Тараптар Қазақстан Республикасының заңнамасына сәйкес жауапты.
                </li>
                <li>Оператор Қатысушы тарапынан техникалық ақаулар немесе Платформа талаптарының орындалмауы салдарынан
                    туындаған залалдар үшін жауапты емес.
                </li>
                <li>Қатысушы логин мен құпиясөздің құпиялылығына және орналастырылған ақпараттың дұрыстығына жауап
                    береді.
                </li>
            </ul>

            <h2 className="text-lg font-semibold">6. ТӨТЕНШЕ ЖАҒДАЙЛАР (FORCE MAJEURE)</h2>
            <p>Төтенше жағдайларға табиғи апаттар, әскери қақтығыстар, мемлекеттік органдардың актілері және басқа да
                күтпеген жағдайлар жатады. Зардап шеккен тарап басқа тарапқа 3 жұмыс күні ішінде хабарлауы тиіс.</p>

            <h2 className="text-lg font-semibold">7. ҚҰПИЯЛЫЛЫҚ</h2>
            <p>Тараптар коммерциялық құпияларды, техникалық ақпаратты және қаржылық шарттарды жария етпеуге келіседі.
                Бұл міндеттеме Шарт бұзылғаннан кейін 3 жыл бойы жарамды.</p>

            <h2 className="text-lg font-semibold"> 8. ШАРТТЫҢ МЕРЗІМІ ЖӘНЕ БҰЗЫЛУЫ</h2>
            <ul className="list-disc pl-6">
                <li>Шарт ағымдағы күнтізбелік жылдың соңына дейін жарамды және тараптардың бірі 30 күн бұрын жазбаша
                    түрде хабарламаса, автоматты түрде ұзартылады.
                </li>
                <li>Төлем жасалмаған немесе Шарттың шарттары бұзылған жағдайда Оператор Шартты тоқтата немесе бұза
                    алады.
                </li>
                <li>Барлық өзгерістер сайтта жарияланады. Қатысушы 5 күн ішінде қарсылық білдіре алады. Үнсіздік келісім
                    деп есептеледі.
                </li>
            </ul>

            <h2 className="text-lg font-semibold">9. ДАУЛАРДЫ ШЕШУ</h2>
            <p>Барлық даулар 15 жұмыс күні ішінде жауап беруді көздейтін жазбаша шағым тәртібі арқылы шешіледі. Егер
                шешілмесе, даулар Оператор тіркелген жерде сот арқылы қаралады.</p>

            <h2 className="text-lg font-semibold">10. ҚОСЫМШАЛАР</h2>
            <ul className="list-disc pl-6">
                <li>1-қосымша: Тіркеу формасы</li>
                <li>2-қосымша: Платформа регламенті</li>
                <li>3-қосымша: Тарифтік жоспарлар</li>
            </ul>

            <p className="italic text-gray-600">
                Бұл Шарт қоғамдық оферталар мен электрондық коммерция стандарттарына арналған халықаралық тәжірибелерге
                сәйкес келтірілген, оның ішінде ЮНСИТРАЛ Электрондық Сауда Туралы Үлгі Заңы, ISO 20400 (Тұрақты сатып
                алу) және Жалпы деректерді қорғау регламенті (GDPR) талаптарына сәйкес келеді.
            </p>
        </CardContent>
    )
}
